<template lang="pug">
yz-dialog(v-if="showDialog" v-model="showDialog" width="500" persistent scrollable)
  yz-card
    yz-dialog-normal-header(title="Edit panel note" @close="onCloseDialog")
    yz-dialog-normal-content
      //- Panel name (read-only)
      div.yz-medium-body-xs.text-neutral-700.mt-4 Panel
      yz-text-field.mt-1(:value="panelName" hide-details readonly background-color="neutral-200")

      //- Amount (read-only)
      div.yz-medium-body-xs.text-neutral-700.mt-4 Amount
      yz-text-field.mt-1(:value="displayAmount" hide-details readonly background-color="neutral-200")

      //- Panel note (editable)
      div.yz-medium-body-xs.text-neutral-700.mt-4 Panel note
      yz-textarea.mt-1(v-model="note" placeholder="Enter panel note..." rows="4" auto-grow hide-details)
    yz-dialog-normal-actions(save-label="Save" cancel-label="Cancel" :loading="isLoading" @save="onSave" @cancel="onCancel")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    registration: {
      type: Object,
      default: () => ({})
    },
    amount: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      note: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      leadPid: 'treatment/getLeadPid'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    panelName () {
      return this.registration?.default_payment?.panel?.name || ''
    },
    displayAmount () {
      if (!this.amount) return this.$options.filters.displayPrice(0, this.$currency)
      return this.$options.filters.displayPrice(
        Math.round(Number(this.amount) * this.$currency.multiplier),
        this.$currency
      )
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.setData()
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.note = this.registration?.default_payment?.note || null
    },
    onCloseDialog () {
      this.showDialog = false
    },
    onCancel () {
      this.showDialog = false
    },
    onSave () {
      this.saveData()
    },
    async saveData () {
      this.isLoading = true

      // Prepare the payload with complete default_payment object
      const payload = {
        default_payment: {
          type: 'panel',
          panel: this.registration?.default_payment?.panel?.id || null,
          note: this.note,
          staff_id: this.registration?.default_payment?.staff_id || null
        }
      }

      try {
        await this.$axios.patch(`/clinics/${this.company.slug}/registrations/${this.leadPid}`, payload)

        // Emit refetch event to parent to refresh payment data
        this.$emit('updated', this.note)

        this.showDialog = false
        this.showMessage(['success', 'Panel note updated successfully'])
      } catch (err) {
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response?.data) {
          if (err.response.data.detail) {
            message = err.response.data.detail
          } else {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) { message = data }
          }
        }
        this.showMessage(['error', message])
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
